var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHyperpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 189 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 0.25C42.75 0.25 0.75 42.25 0.75 94C0.75 145.75 42.75 187.5 94.5 187.5C146.25 187.5 188.25 145.5 188.25 93.75C188.25 42 146.25 0.25 94.5 0.25ZM119.25 114.25C113 114.25 97.5 114.5 97.5 114.5L90.5 141.5H61.5L68.25 115H23L30.25 93.25C30.25 93.25 109 93.5 115.5 93.25C122 93 132 91.5 132.25 78.5C132.5 60.75 105.25 61.75 103 77.5C101.5 87.5 101.5 90 101.5 90H75.75L80.75 66.5H39L45.25 44.5C45.25 44.5 106.5 44.75 118 44.75C129.5 44.75 160.25 47.75 160.25 76C160.25 107 130.5 114.25 119.25 114.25V114.25Z",
    fill: "#1A72FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperpay);
export default __webpack_public_path__ + "static/media/hyperpay.e53e4dee1603d584a40f496c031edf7d.svg";
export { ForwardRef as ReactComponent };